import loadable from 'utils/loadable';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "modal.pdf.modal" */ 'components/PdfModal/pdf-modal.component'
    ),
);
